import React from 'react';
import Products from './Products/Products';

function ProductsHome() {
  return <Products />;
}

export default ProductsHome;
